const toc_content = {
    init() {
        const sections = document.querySelectorAll('.js-toc-page');
        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            const content = section.querySelector('.js-toc-content');
            const toc = section.querySelector('[data-toc]');
            const tocList = section.querySelector('[data-toc-list]');
            const descriptionAnchor = section.querySelector('[data-description-anchor]');

            if (!content || !toc || !tocList || !descriptionAnchor) {
                return;
            }

            const headings = [...content.querySelectorAll('h2, h3')];
            const links = [];
            const targets = [descriptionAnchor];
            const usedIds = new Set();

            const descriptionItem = document.createElement('li');
            const descriptionLink = document.createElement('a');
            descriptionLink.href = '#description-of-role';
            descriptionLink.className = 'toc-link';
            descriptionLink.textContent = 'Description of Role';
            descriptionItem.appendChild(descriptionLink);
            tocList.appendChild(descriptionItem);
            links.push(descriptionLink);

            headings.forEach((heading, index) => {
                const fallbackId = `heading-${index + 1}`;
                const source = heading.id || heading.textContent || fallbackId;
                let slug = source
                    .toLowerCase()
                    .trim()
                    .replace(/[^a-z0-9\s-]/g, '')
                    .replace(/\s+/g, '-')
                    .replace(/-+/g, '-');

                if (!slug) {
                    slug = fallbackId;
                }

                while (usedIds.has(slug)) {
                    slug = `${slug}-${index + 1}`;
                }
                usedIds.add(slug);
                heading.id = slug;

                const item = document.createElement('li');
                const link = document.createElement('a');

                link.href = `#${slug}`;
                link.className = 'toc-link';
                link.textContent = heading.textContent.trim() || `Section ${index + 1}`;

                item.appendChild(link);
                tocList.appendChild(item);
                links.push(link);
                targets.push(heading);
            });

            let ticking = false;
            let clickedIndex = -1;

            const setActive = (activeIndex) => {
                links.forEach((link, index) => {
                    link.classList.toggle('is-active', index === activeIndex);
                });
            };

            // Absolute positions + midpoint thresholds.
            // Each link activates when scrollTop crosses the midpoint between
            // that heading and the previous one — no header offset needed.
            let thresholds = [];
            let sectionAbsTop = 0;
            let sectionAbsBottom = 0;

            const getHeaderHeight = () => {
                const header = document.querySelector('.site-header');
                return header ? (header.offsetHeight + 20) : 0;
            };

            const computeAbsPositions = () => {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const headerHeight = getHeaderHeight();
                sectionAbsTop = section.getBoundingClientRect().top + scrollTop;
                sectionAbsBottom = sectionAbsTop + section.offsetHeight;
                const absTops = targets.map(t => t.getBoundingClientRect().top + scrollTop - headerHeight);
                thresholds = absTops.map((absTop, i) =>
                    i === 0 ? absTop : (absTops[i - 1] + absTop) / 2
                );
            };

            computeAbsPositions();
            window.addEventListener('resize', computeAbsPositions);

            links.forEach((link, linkIndex) => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    clickedIndex = linkIndex;
                    setActive(linkIndex);

                    const target = targets[linkIndex];
                    const targetTop = target.getBoundingClientRect().top + window.pageYOffset - getHeaderHeight();

                    window.scrollTo({ top: targetTop, behavior: 'smooth' });
                });
            });

            const updateActive = () => {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

                if (scrollTop > sectionAbsBottom) {
                    clickedIndex = -1;
                    setActive(-1);
                    ticking = false;
                    return;
                }

                // After a click, keep the clicked link active until scrollTop
                // genuinely crosses its midpoint threshold in either direction.
                if (clickedIndex !== -1) {
                    const lo = thresholds[clickedIndex];
                    const hi = clickedIndex + 1 < thresholds.length
                        ? thresholds[clickedIndex + 1]
                        : Infinity;

                    if (scrollTop >= lo && scrollTop < hi) {
                        setActive(clickedIndex);
                        ticking = false;
                        return;
                    }
                    clickedIndex = -1;
                }

                let activeIndex = 0;
                thresholds.forEach((threshold, index) => {
                    if (scrollTop >= threshold) {
                        activeIndex = index;
                    }
                });

                setActive(activeIndex);
                ticking = false;
            };

            const onScroll = () => {
                if (!ticking) {
                    window.requestAnimationFrame(updateActive);
                    ticking = true;
                }
            };

            window.addEventListener('scroll', onScroll, { passive: true });
            window.addEventListener('resize', onScroll);
            onScroll();
        });
    },
};

export default toc_content;
